import { useTranslation } from 'react-i18next';

import { Skeleton } from '@/components/ui/Skeleton';

/**
 * The loading state of `DESIGN.md` §8: skeletons in `paper-sunken` **shaped like the content**,
 * never a centred spinner on a full page.
 *
 * It is shaped like the page title and Section 1 — the two things every viewer gets — and
 * deliberately draws nothing for Sections 2 to 5. Which of those a caller receives is decided by
 * the API in the body (ADR 0015), so a placeholder for them would be the screen guessing: an
 * Interviewer would watch three sections appear and vanish, which is exactly the "layout that jumps
 * when data lands" §8 forbids. The analysis sections append below Section 1 instead, and a period
 * change keeps the previous data on screen rather than returning here.
 */
export function DashboardSkeleton() {
  const { t } = useTranslation('dashboard');

  return (
    <div aria-busy="true">
      <span className="sr-only">{t('loading')}</span>

      <Skeleton className="h-7 w-48" />

      <div className="mt-10">
        <Skeleton className="h-4 w-40" />
        <div className="mt-4 flex items-end gap-8">
          <Skeleton className="h-12 w-24" />
          <Skeleton className="h-16 w-28" />
          <Skeleton className="h-16 w-28" />
          <Skeleton className="h-16 w-28" />
        </div>
        <div className="mt-6 space-y-px border-y border-rule">
          {Array.from({ length: 5 }, (_, index) => (
            <Skeleton key={index} className="h-10 w-full" />
          ))}
        </div>
      </div>
    </div>
  );
}
